import React, { useState } from "react";
import Navbar from "../../navbar/navbar";
import { api } from "../../../services/api";
import { Link, Navigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { vhostV1 } from "../../funcoes";
import SweetAlert from "react-bootstrap-sweetalert";
import FooterBar from "../../footer/footerBar";

function NovaFinalizadora() {
  const { tag } = useParams();
  const { id } = useParams();

  const [descricaoV, setDescricao] = useState("");
  const [finalizadoraV, setFinalizadora] = useState([]);
  const [tefV, setTef] = useState(0);
  const [conta_bancariaV, setConta_bancaria] = useState(0);
  const [prazoV, setPrazo] = useState(0);
  const [descontoV, setDesconto] = useState(0);
  const [acrescimo, setAcrescimo] = useState(0);
  const [nr_parcelasV, setNr_parcelas] = useState(0);
  const [tab_precoV, setTab_preco] = useState(0);
  const [jurosV, setJuros] = useState(0);
  const [vlr_minimo_opV, setValor_minimo_op] = useState(0);
  const [duplicataV, setDuplicata] = useState("F");
  const [cartaoV, setCartao] = useState("0");
  const [sintetico, setSintetico] = useState(0);
  const [analitico, setAnalitico] = useState(0);
  const [desc_impV, setDesc_imp] = useState("dinheiro");
  const [permit_trocoV, setPermit_troco] = useState("N");
  const [cod_cedenteV, setCod_cedente] = useState("");
  const [cadastrado_por, setCadastrado_Por] = useState(99);
  const [alterado_por, setAlterado_Por] = useState(99);
  const [cadastrado_em, setCadastrado_em] = useState("");
  const [alterado_em, setAlteradoEm] = useState("");
  const [mobile, setMobile] = useState("N");
  const [planoAnalitico, setPlanoAnalitico] = useState([]);
  const [planoSintetico, setPlanoSintetico] = useState([]);
  const [codFinalizadora, setCodFinalizadora] = useState(-1);
  const [tipo_Doc, setTipo_doc] = useState("00");
  const [tipo_mov, setTipo_mov] = useState(0);
  const [finalizadoraImp, setFinalizadoraImp] = useState([]);

  const [sucesso, setSucesso] = useState("N");
  const [mensagem, setMensagem] = useState("");
  const [sResult, setSresult] = useState(0);
  const [erroValidacao, setErrovalidacao] = useState(false);
  const [msgErro, setmsgErro] = useState("");
  const [busca, setBusca] = useState("");
  const [banco, setBanco] = useState([]);
  const [tipoMovimentoBancario, setTipoMovimentoBancario] = useState([]);
  const [contaBancaria, setContaBancaria] = useState(0);
  const [usaAd, setUsaAd] = useState("N");
  const [tipoAd, setTipoAd] = useState("");
  const [gerCr, setGerCr] = useState("N");
  const [gerBco, setGerBco] = useState("N");
  const [gerCcd, setGerCcd] = useState("N");
  const [gerTotal, setGerTotal] = useState("N");
  

  var data = new Date();

  const dataAtual = data.toSRIFormatString();

  let config = {
    headers: {
      Authorization: localStorage.getItem("token"),
    },
  };

  const handleGerCrChange = (event) => {
  setGerCr(event.target.checked ? "S" : "N");
};

   const handleGerBcoChange = (event) => {
  setGerBco(event.target.checked ? "S" : "N");
};

   const handleGerCcdChange = (event) => {
  setGerCcd(event.target.checked ? "S" : "N");
};

   const handleGerTotalChange = (event) => {
  setGerTotal(event.target.value);
};

  const handleChangeTroco = (event) => {
    setPermit_troco(event.target.value);
  };

  const handleChangeMobile = (event) => {
    setMobile(event.target.value);
  };

  const handleChangeAd = (event) => {
    setUsaAd(event.target.value);
  };

  const handleChangeTipoAd = (event) => {
    setTipoAd(event.target.value);
  };

  const handleChangeCartao = (event) => {
    setCartao(event.target.value);
  };

  const inputs = document.querySelectorAll("input, select");
  // Adicione um manipulador de eventos para o evento "keydown" em cada entrada ou select
  inputs.forEach((input) => {
    input.addEventListener("keydown", (e) => {
      // Se a tecla pressionada for Enter
      if (e.key === "Enter") {
        e.preventDefault(); // evita que a tecla "Enter" envie um formulário, se aplicável

        // Obtenha o índice do elemento atual
        const currentIndex = Array.from(inputs).indexOf(e.target);

        // Mova o foco para o próximo elemento de entrada ou select
        const nextIndex = currentIndex + 1;
        if (nextIndex < inputs.length) {
          inputs[nextIndex].focus();
        }
      }
    });
  });

  useEffect(
    function () {
      api
        .post(
          vhostV1("webcash/banco"),
          {
            loja: localStorage.getItem("loja"),
            empresa: 1,
            busca: busca,
          },
          config
        )
        .then(function (response) {
          if (response && response.data && response.data.dados) {
            setBanco(response.data.dados);
            console.log(response.data.dados);
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    [busca]
  );

 

  useEffect(function () {
    api
      .get(vhostV1("webcash/finalizadoras/RetornaFinalizadora/" + id), config)
      .then(function (response) {
        console.log(response);

        if (response && response.data && response.data.dados) {
          console.log(response.data.dados);
          setCodFinalizadora(response.data.dados.COD_FINALIZADORA);
          setFinalizadora(response.data.dados.COD_FINALIZADORA);
          setDescricao(response.data.dados.DESCRICAO);
          setTef(response.data.dados.TEF);
          setConta_bancaria(response.data.dados.CONTA_BANCARIA);
          setPrazo(response.data.dados.PRAZO);
          setDesconto(response.data.dados.DESCONTO);
          setNr_parcelas(response.data.dados.NR_PARCELAS);
          setTab_preco(response.data.dados.TAB_PRECO);
          setJuros(response.data.dados.JUROS);
          setValor_minimo_op(response.data.dados.VLR_MINIMO_OP);
          setDuplicata(response.data.dados.DUPLICATA);
          setCartao(response.data.dados.CARTAO);
          setSintetico(response.data.dados.SINTETICO);
          setAnalitico(response.data.dados.ANALITICO);
          setDesc_imp(response.data.dados.DESC_IMP);
          setPermit_troco(response.data.dados.PERMT_TROCO);
          setCod_cedente(response.data.dados.COD_CEDENTE);
          setTipo_doc(response.data.dados.TIPO_DOC);
          setAlteradoEm(response.data.dados.ALTERADO_EM);
          setAlterado_Por(response.data.dados.ALTERADO_POR);
          setCadastrado_em(response.data.dados.CADASTRADO_EM);
          setCadastrado_Por(response.data.dados.CADASTRADO_POR);
          setUsaAd(response.data.dados.USA_AD);
          setTipoAd(response.data.dados.TIPO_AD);
          setTipo_mov(response.data.dados.TIPO_MOVIMENTO);
          setGerBco(response.data.dados.GERBCO);
          setGerCcd(response.data.dados.GERCCD);
          setGerCr(response.data.dados.GERCR);
          setGerTotal(response.data.dados.GERTOTAL);
          if(response.data.dados.MOBILE !== null){
            setMobile(response.data.dados.MOBILE);
          }
          
        }
      });
  }, []);

  const json = {              
              COD_FINALIZADORA: Number(codFinalizadora),
              DESCRICAO: descricaoV.toUpperCase(),
              TEF: Number(tefV),
              CADASTRADO_POR: localStorage.getItem("colaborador"),
              CADASTRADO_EM: cadastrado_em,
              ALTERADO_POR: localStorage.getItem("colaborador"),
              CONTA_BANCARIA: Number(contaBancaria),
              DESCONTO: Number(descontoV),
              CARTAO: String(cartaoV),
              NR_PARCELAS: Number(nr_parcelasV),
              JUROS: Number(jurosV),
              VLR_MINIMO_OP: Number(vlr_minimo_opV),
              SINTETICO: Number(sintetico),
              ANALITICO: Number(analitico),
              DESC_IMP: desc_impV,
              PERMT_TROCO: permit_trocoV,
              TIPO_DOC: tipo_Doc,
              TIPO_MOVIMENTO: Number(tipo_mov),
              TIPO_AD: tipoAd,
              USA_AD: usaAd,
              GERCR: gerCr,
              GERBCO: gerBco,
              GERCCD: gerCcd,
              GERTOTAL: gerTotal,
              MOBILE: mobile
            };

  console.log(analitico);

  console.log(json);

  useEffect(function () {
    api
      .get(vhostV1("webcash/finalizadoras/ListaFinalizadorasImp"), config)
      .then(function (response) {
        console.log(response);
        if (response && response.data && response.data.dados) {
          setFinalizadoraImp(response.data.dados);

          setSresult(1);
        } else {
          setSresult(0);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  function SalvaFinalizadora() {
    {
      if (descricaoV.length > 30) {
        setmsgErro("Descrição do banco maior que permitido");
        setErrovalidacao(true);
      } else if (desc_impV.length > 50) {
        setmsgErro("desconto imp maior que permitido");
        setErrovalidacao(true);
      } else if (descricaoV.length === 0) {
        setmsgErro("descrição não pode ser vazio");
        setErrovalidacao(true);
      } else if (sintetico.length === 0) {
        setmsgErro("Selecione um sintetico!");
        setErrovalidacao(true);
      } else if (analitico.length === 0) {
        setmsgErro("Selecione um analitico!");
        setErrovalidacao(true);
      } else {
        // fim do valida tamanhos

        //   e.preventDefault(e);
        api.post(
            vhostV1("webcash/finalizadoras/inserirFinalizadora"),
            {              
              COD_FINALIZADORA: Number(codFinalizadora),
              DESCRICAO: descricaoV.toUpperCase(),
              TEF: Number(tefV),
              CADASTRADO_POR: Number(localStorage.getItem("colaborador")),
              CADASTRADO_EM: cadastrado_em,
              ALTERADO_POR: Number(localStorage.getItem("colaborador")),
              CONTA_BANCARIA: Number(contaBancaria),
              DESCONTO: Number(descontoV),
              CARTAO: String(cartaoV),
              NR_PARCELAS: Number(nr_parcelasV),
              JUROS: Number(jurosV),
              VLR_MINIMO_OP: Number(vlr_minimo_opV),
              SINTETICO: Number(sintetico),
              ANALITICO: Number(analitico),
              DESC_IMP: desc_impV,
              PERMT_TROCO: permit_trocoV,
              TIPO_DOC: tipo_Doc,
              TIPO_MOVIMENTO: Number(tipo_mov),
              TIPO_AD: tipoAd,
              USA_AD: usaAd,
              GERCR: gerCr,
              GERBCO: gerBco,
              GERCCD: gerCcd,
              GERTOTAL: gerTotal,
              MOBILE: mobile,
              ACRESCIMO: Number(acrescimo),

            },
            config
          )

          .then(function (response) {
            console.log(response);

            if (response.data.result === 1) {
              setMensagem("");
              setSucesso("S");
            } else {
              setmsgErro(response);
            }
          })
          .catch((erro) => {
            setMensagem(erro);
            setSucesso("N");
            console.log("ERRO");
          });
      }
    }
  }

  function buscaAnalitico(e) {
    api
      .post(
        vhostV1("webcash/planoConta/planoAnalitico"),
        {
          loja: localStorage.getItem("loja"),
          empresa: 1,
          sintetico: e,
        },
        config
      )
      .then(function (response) {
        console.log(response);

        setPlanoAnalitico(response.data.dados);
        setSintetico(e);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(function () {
    api
      .post(
        vhostV1("webcash/planoConta/planoSintetico"),
        {
          loja: localStorage.getItem("loja"),
          empresa: 0,
        },
        config
      )
      .then(function (response) {
        console.log(response);
        setPlanoSintetico(response.data.dados);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  useEffect(function () {
    api
      .get(vhostV1("webcash/planoConta/tipos-movimento-bancario"), config)
      .then(function (response) {
        console.log(response);
        setTipoMovimentoBancario(response.data.dados);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  useEffect(
    function () {
      if (sintetico > 0) {
        buscaAnalitico(Number(sintetico));
      }
    },
    [sintetico]
  );

  function formatDateToDDMMYYYY(isoDateString) {
    const date = new Date(isoDateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Janeiro é 0
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  return (
    <div className="container-fluid titulo">
      <Navbar />
      <div className="offset-lg-1 col-lg-10">
        <h2>Cadastro de Finalizadora</h2>
        <hr />

        <form className="row tela">
          <div className="col-1 mb-3">
            <label htmlFor="inputParcelas" className="form-label">
              Código
            </label>
            <input
              type="text"
              onChange={(e) => setCodFinalizadora(e.target.value)}
              value={codFinalizadora}
              className="form-control"
              id="inputParcelas"
              readOnly
            />
          </div>

          <div className="col-5 mb-3">
            <label htmlFor="inputDescricao" className="form-label">
              Descrição
            </label>
            <input
              type="text"
              onChange={(e) => setDescricao(e.target.value)}
              value={descricaoV}
              className="form-control"
              id="inputDescricao"
            />
          </div>

          {/* <div className="col-2 mb-3">
                  <label htmlFor="inputDesconto" className="form-label">Desconto</label>
                  <input type="text" onChange={(e) => setDesconto(e.target.value)} value={descontoV} className="form-control" id="inputDesconto" />
              </div> */}
          <div className="col-4 mb-3">
            <label htmlFor="inputTipoMov" className="form-label">
              Descrição ECF
            </label>
            <select
              id="inputTipoMov"
              value={desc_impV}
              onChange={(e) => setDesc_imp(e.target.value)}
              className="form-select"
            >
              <option value={0}>SELECIONE</option>
              {finalizadoraImp.map((finalizadora) => (
                <option
                  key={finalizadora.DECRICAO}
                  value={finalizadora.DECRICAO}
                >
                  {finalizadora.DECRICAO}
                </option>
              ))}
            </select>
          </div>

          <div className="col-1 mb-3">
            <label htmlFor="inputParcelas" className="form-label">
              Nº Parcelas
            </label>
            <input
              type="text"
              onChange={(e) => setNr_parcelas(e.target.value)}
              value={nr_parcelasV}
              className="form-control"
              id="inputParcelas"
            />
          </div>

          <div className="col-1 mb-3">
            <label htmlFor="inputParcelas" className="form-label">
              Tipo_Doc
            </label>
            <input
              type="text"
              onChange={(e) => setTipo_doc(e.target.value)}
              value={tipo_Doc}
              className="form-control"
              id="inputParcelas"
            />
          </div>

          <div className="row">
            <div className="col-md-3 mb-3">
              <label htmlFor="inputTef" className="form-label">
                Operadora de Cartão?
              </label>
              <select
                value={tefV}
                id="inputTef"
                onChange={(e) => setTef(e.target.value)}
                className="form-select"
              >
                <option value={99}>Selecione uma opção</option>
                <option value={0}>000 - Não Possui TEF</option>
                <option value={1}>001 - Tef Discado/PayGo/Autta</option>
                <option value={2}>002 - POS sem integração</option>
                <option value={3}>003 - Reservado</option>
                <option value={4}>004 - SITEF</option>
                <option value={5}>005 - GiftCard</option>
                <option value={6}>006 - POS(Moderninhas PRO)</option>
                <option value={7}>007 - Reservado</option>
                <option value={8}>008 - Reservado</option>
                <option value={9}>009 - Crediário</option>
                <option value={10}>010 - Vale Troca/Presente</option>
                <option value={11}>011 - Documento Interno</option>
                <option value={14}>014 - Smart POS</option>
              </select>
            </div>

            <div className="col-4 mb-3">
              <label htmlFor="inputTipoMov" className="form-label">
                Conta Bancaria
              </label>
              <select
                id="inputTipoMov"
                value={contaBancaria}
                onChange={(e) => setContaBancaria(e.target.value)}
                className="form-select"
              >
                {banco.map((e) => (
                  <option key={e.SEQ_BANCO} value={e.SEQ_BANCO}>
                    {e.DESCRICAO}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-2 mb-3">
              <h5 className="mt-4">Troco</h5>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="jurosOptions"
                  id="jurosNenhum"
                  value="N"
                  checked={permit_trocoV === "N"}
                  onChange={handleChangeTroco}
                />
                <label className="form-check-label" htmlFor="jurosNenhum">
                  Não
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="jurosOptions"
                  id="jurosValor"
                  value="S"
                  checked={permit_trocoV === "S"}
                  onChange={handleChangeTroco}
                />
                <label className="form-check-label" htmlFor="jurosValor">
                  Sim
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="jurosOptions"
                  id="jurosPercentual"
                  value="V"
                  checked={permit_trocoV === "V"}
                  onChange={handleChangeTroco}
                />
                <label className="form-check-label" htmlFor="jurosPercentual">
                  Vale
                </label>
              </div>
            </div>
            <div className="col-2 mb-3">
              <h5 className="mt-4">Gerar</h5>
              <div className="form-check">
              <input
               className="form-check-input"
               type="checkbox"
               id="usaAdCheckbox"
               checked={gerCr === "S"}
               onChange={handleGerCrChange}
               />
              <label className="form-check-label" htmlFor="usaAdCheckbox">
               Titulos a Receber
              </label>
              </div>

               <div className="form-check">
              <input
               className="form-check-input"
               type="checkbox"
               id="usaAdCheckbox"
               checked={gerBco === "S"}
               onChange={handleGerBcoChange}
               />
              <label className="form-check-label" htmlFor="usaAdCheckbox">
               Lanc. Banco
              </label>
              </div> 

               <div className="form-check">
              <input
               className="form-check-input"
               type="checkbox"
               id="usaAdCheckbox"
               checked={gerCcd === "S"}
               onChange={handleGerCcdChange}
               />
              <label className="form-check-label" htmlFor="usaAdCheckbox">
               Cartão
              </label>
              </div>
            </div>

            <div className="col-1 mb-3">
              <h5 className="mt-4">Totaliza</h5>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="gerTotalOptions"
                  id="jurosNenhum"
                  value="N"
                  checked={gerTotal === "N"}
                  onChange={handleGerTotalChange}
                />
                <label className="form-check-label" htmlFor="jurosNenhum">
                  Não
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="gerTotalOptions"
                  id="jurosValor"
                  value="S"
                  checked={gerTotal=== "S"}
                  onChange={handleGerTotalChange}
                />
                <label className="form-check-label" htmlFor="jurosValor">
                  Sim
                </label>
              </div>
            </div>
          </div>

          {/* <div className="col-2 mb-3">
                  <label htmlFor="inputPrazo" className="form-label">Prazo</label>
                  <input type="text" onChange={(e) => setPrazo(e.target.value)} value={prazoV} className="form-control" id="inputPrazo" />
              </div> */}

          <h5 className="mt-1">Dados Complementares</h5>
          <hr />

          <h5>Usa Padrão Acréscimo e/ou Desconto</h5>
          
          <div className="row">
            <h6>Aplica</h6>
            <div className="col-1 mb-3">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="usaAcrescDesconto"
                  id="padraoNao"
                  value="N"
                  checked={usaAd === "N"}
                  onChange={handleChangeAd}
                />
                <label className="form-check-label" htmlFor="padraoNao">
                  Não
                </label>
              </div>
            </div>
            <div className="col-1 mb-3">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="usaAcrescDesconto"
                  id="padraoSim"
                  value="S"
                  checked={usaAd === "S"}
                  onChange={handleChangeAd}
                />
                <label className="form-check-label" htmlFor="padraoSim">
                  Sim
                </label>
              </div>
            </div>

            <h6>Tipo</h6>

            <div className="col-1 mb-3">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="tipoAcrescDesconto"
                  id="padraoNao"
                  value="$"
                  checked={tipoAd === "$"}
                  onChange={handleChangeTipoAd}
                />
                <label className="form-check-label" htmlFor="padraoNao">
                  $
                </label>
              </div>
            </div>
            <div className="col-1 mb-3">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="tipoAcrescDesconto"
                  id="padraoSim"
                  value="%"
                  checked={tipoAd === "%"}
                  onChange={handleChangeTipoAd}
                />
                <label className="form-check-label" htmlFor="padraoSim">
                  %
                </label>
              </div>
            </div>
            <div className="col-1 mb-3">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="tipoAcrescDesconto"
                  id="padraoSim"
                  value="PROD"
                  checked={tipoAd === "PROD"}
                  onChange={handleChangeTipoAd}
                />
                <label className="form-check-label" htmlFor="padraoSim">
                  PROD
                </label>
              </div>
            </div>

            <div className="col-2 mb-3">
              <label htmlFor="inputValorMinimo" className="form-label">
                Acréscimo
              </label>
              <input
                type="text"
                onChange={(e) => setAcrescimo(e.target.value)}
                value={acrescimo.toFixed(2)}
                className="form-control"
                id="inputValorMinimo"
              />
            </div>

            <div className="col-1 mb-3">
              <label htmlFor="inputValorMinimo" className="form-label">
                Desconto
              </label>
              <input
                type="text"
                onChange={(e) => setDesconto(e.target.value)}
                value={descontoV.toFixed(2)}
                className="form-control"
                id="inputValorMinimo"
              />
            </div>

            <div className="col-2 mb-3">
              <label htmlFor="inputValorMinimo" className="form-label">
                Valor Mínimo
              </label>
              <input
                type="text"
                onChange={(e) => setValor_minimo_op(e.target.value)}
                value={vlr_minimo_opV}
                className="form-control"
                id="inputValorMinimo"
              />
            </div>

            <div className="col-1 mb-3">
              <h6 className="mt-2 mb-3">Cartão</h6>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="cartaoOptions"
                  id="jurosNenhum"
                  value="0"
                  checked={cartaoV === "0"}
                  onChange={handleChangeCartao}
                />
                <label className="form-check-label" htmlFor="jurosNenhum">
                  Não
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="cartaoOptions"
                  id="jurosValor"
                  value="1"
                  checked={cartaoV=== "1"}
                  onChange={handleChangeCartao}
                />
                <label className="form-check-label" htmlFor="jurosValor">
                  Sim
                </label>
              </div>
              
            </div>

            <div className="col-1 mb-3">
              <label htmlFor="inputJuros" className="form-label">
                Juros
              </label>
              <input
                type="text"
                onChange={(e) => setJuros(e.target.value)}
                value={jurosV}
                className="form-control"
                id="inputJuros"
              />
            </div>
          </div>

          <h5 className="mt-4">Associação com Plano de Contas</h5>
          <hr />
          <div className="col-4 mb-3">
            <label htmlFor="inputSintetico" className="form-label">
              Sintético
            </label>
            <select
              id="inputSintetico"
              value={sintetico}
              onChange={(e) => buscaAnalitico(e.target.value)}
              className="form-select"
            >
              <option value={0}>SELECIONE O SINTETICO</option>
              {planoSintetico.map((ps) => (
                <option key={ps.SINTETICO} value={ps.SINTETICO}>
                  {ps.DESCRICAO}
                </option>
              ))}
            </select>
          </div>

          {planoSintetico.length > 0 && (
            <div className="col-4 mb-3">
              <label htmlFor="inputAnalitico" className="form-label">
                Analítico
              </label>
              <select
                id="inputAnalitico"
                value={analitico}
                onChange={(e) => setAnalitico(e.target.value)}
                className="form-select"
              >
                <option value={99}>SELECIONE O ANALITICO</option>
                {planoAnalitico.map((pa) => (
                  <option key={pa.ANALITICO} value={pa.ANALITICO}>
                    {pa.DESCRICAO}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="col-4 mb-3">
            <label htmlFor="inputTipoMov" className="form-label">
              Tipo Movimento Bancario
            </label>
            <select
              id="inputTipoMov"
              value={tipo_mov}
              onChange={(e) => setTipo_mov(e.target.value)}
              className="form-select"
            >
              <option value={99}>SELECIONE</option>
              {tipoMovimentoBancario.map((movimento) => (
                <option
                  key={movimento.SEQ_MOVIMENTO}
                  value={movimento.SEQ_MOVIMENTO}
                >
                  {movimento.DESCRICAO}
                </option>
              ))}
            </select>
          </div>

          <h5 className="mt-4">Eventos Cadastro</h5>
          <hr />

          <div className="col-2 mb-3">
            <label htmlFor="inputValorMinimo" className="form-label">
              Data Alteração
            </label>
            <input
              type="text"
              onChange={(e) => setAlteradoEm(e.target.value)}
              value={
                alterado_em !== null
                  ? formatDateToDDMMYYYY(alterado_em)
                  : "Não há informações"
              }
              className="form-control"
              id="inputValorMinimo"
              readOnly
            />
          </div>

          <div className="col-2 mb-3">
            <label htmlFor="inputValorMinimo" className="form-label">
              Alterado Por
            </label>
            <input
              type="text"
              onChange={(e) => setAlterado_Por(e.target.value)}
              value={alterado_por}
              className="form-control"
              id="inputValorMinimo"
              readOnly
            />
          </div>

          <div className="col-2 mb-3">
            <label htmlFor="inputValorMinimo" className="form-label">
              Data Cadastro
            </label>
            <input
              type="text"
              onChange={(e) => setCadastrado_em(e.target.value)}
              value={
                cadastrado_em !== null
                  ? formatDateToDDMMYYYY(cadastrado_em)
                  : "Não há informações"
              }
              className="form-control"
              id="inputValorMinimo"
              readOnly
            />
          </div>

          <div className="col-2 mb-3">
            <label htmlFor="inputValorMinimo" className="form-label">
              Cadastrado Por
            </label>
            <input
              type="text"
              onChange={(e) => setCadastrado_Por(e.target.value)}
              value={cadastrado_por}
              className="form-control"
              id="inputValorMinimo"
              readOnly
            />
          </div>

          <div className="col-2 mb-3">
              <h6 className="mt-2 mb-3">Mobile</h6>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="mobileOptions"
                  id="jurosNenhum"
                  value="N"
                  checked={mobile === "N"}
                  onChange={handleChangeMobile}
                />
                <label className="form-check-label" htmlFor="jurosNenhum">
                  Não
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="mobileOptions"
                  id="jurosValor"
                  value="S"
                  checked={mobile=== "S"}
                  onChange={handleChangeMobile}
                />
                <label className="form-check-label" htmlFor="jurosValor">
                  Sim
                </label>
              </div>
              
            </div>

          <div className="col-12 mb-3 ">
            <Link to="/app/finalizadora" className="btn btn-danger">
              Desistir
            </Link>
            {tag !== "0" && (
              <button
                type="button"
                onClick={SalvaFinalizadora}
                className="btn btn-primary ms-2"
              >
                Salvar
              </button>
            )}
          </div>

          {mensagem.length > 0 && (
            <div className="alert alert-danger mt-2">{mensagem}</div>
          )}
          {sucesso === "S" && <Navigate to="/app/finalizadora" />}

          {erroValidacao && (
            <SweetAlert
              danger
              confirmBtnText="OK"
              confirmBtnBsStyle="danger"
              title="Erro"
              onConfirm={() => setErrovalidacao(false)}
            >
              {msgErro}
            </SweetAlert>
          )}
        </form>
      </div>
      <FooterBar />
    </div>
  );
}

export default NovaFinalizadora;
